module.exports = require("core-js/library/fn/set");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/set.js
// module id = 100
// module chunks = 101